import * as Sentry from "@sentry/gatsby";

Sentry.init({
    dsn: "https://9b490813e4c2e19f4faf05021dbe3337@o4505843718750208.ingest.sentry.io/4505843744243712"
});
